export const IS_LOCAL = process.env.NODE_ENV === 'local';
/** True for unit tests, but not for e2e tests. */
export const IS_JEST_TEST = process.env.NODE_ENV === 'test';
export const IS_HOSTED = process.env.NODE_ENV === 'production';
export const IS_STAGING = process.env.ACTUAL_ENV === 'staging';
export const IS_PROD = process.env.ACTUAL_ENV === 'production';
